// src/pages/Instituicoes.js

import React, { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import DataTableInstituicoes from "../components/DataTableInstituicoes";
import axios from "axios";

function Instituicoes() {
  
  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = () => {
    setLoading(true);
    axios.get("instituicoes/")
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar dados das instituições:", error);
      })
      .finally(() => setLoading(false));
  };

  const handleUpdate = () => {
    fetchData(); // Recarrega os dados após uma alteração
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <AdminLayout>
      {loading ? (
        <p>Carregando...</p>
      ) : (
        <DataTableInstituicoes
          title="Instituições"
          newButtonRoute="./novo"
          data={data}
          onUpdate={handleUpdate} // Passa a função de atualização
        />
      )}
    </AdminLayout>
  );
}

export default Instituicoes;